import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import {
  Box,
  Button,
  Typography,
  Paper
} from "@mui/material";
import axios from "axios";

const AdminTerms = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch existing T&C
  useEffect(() => {
    axios.get("/api/terms")
      .then(res => {
        if (res.data?.content) {
          setContent(res.data.content);
        }
      });
  }, []);

  // Save / Update T&C
  const handleSave = async () => {
    setLoading(true);
    await axios.post("/api/terms", { content });
    setLoading(false);
    alert("Terms & Conditions saved successfully!");
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" mb={2}>
        Terms & Conditions (Admin)
      </Typography>

      <ReactQuill
        value={content}
        onChange={setContent}
        theme="snow"
        style={{ height: "300px", marginBottom: "60px" }}
      />

      <Button
        variant="contained"
        onClick={handleSave}
        disabled={loading}
      >
        Save Terms
      </Button>
    </Paper>
  );
};

export default AdminTerms;